import * as React from 'react';
import { Plan, PlanPackageCriterion } from 'fs-api-client';
import { BillingTierDetails } from './BillingTierDetails';
import { capitalizeFirstLetter } from 'src/webportal/utils/utilFunctions';
import { PlanPackage } from './BillingPlanModel';

interface PlanPackageProps {
    planPackage: PlanPackage;
    isNewPackage: boolean;
    currency: string;
    header: string;
    canEdit: boolean;

    onEditClick: (planPackage: PlanPackage | undefined, plan: Plan, isNewPackage: boolean) => void; // TODO check undefined
    onDeleteClicked: (planPackage: PlanPackage | undefined, plan: Plan) => void; // TODO isNewPackage needed?
}

interface PlanPackageState {

}

export class PlanPackageView extends React.Component<PlanPackageProps, PlanPackageState> {

    constructor(props: PlanPackageProps) {
        super(props);
    }

    render() {
        const planPackage = this.props.planPackage;
        const numCriteria = planPackage.includeCriteria.length;
        const numPlans = planPackage.plans.length;
        const showCriteria = !planPackage.isLite  &&
        (numPlans > 1 || numCriteria > 1 ||
            (numCriteria > 0 &&
                planPackage.includeCriteria[0].subscriptionType === PlanPackageCriterion.SubscriptionTypeEnum.None));

        return this.props.planPackage.plans.map((plan, index: number) => {
            return (
                <div className="row listItem"  key={index}>
                    <div className="fullWidth">
                        <div className="spaceBetween vcenter">
                            <div className="tierList">
                                <div>
                                    <h2>{this.props.header}</h2>
                                    {showCriteria && planPackage.includeCriteria.map((criterion, criterionIndex) => { return (
                                        <ul className="details" key={criterionIndex}>
                                            <li>{capitalizeFirstLetter(criterion.subscriptionType.toString())}</li>
                                            <li>{capitalizeFirstLetter(plan.dimension.toString())}</li>
                                            <li>{capitalizeFirstLetter(criterion.storageProvider)}</li>
                                            <li>{capitalizeFirstLetter(criterion.storageOwner.toString())}</li>
                                        </ul>
                                    ); })}
                                </div>
                                <BillingTierDetails
                                    currency={this.props.currency}
                                    billingTiers={plan.tiers}
                                    planDimension={plan.dimension}
                                />
                            </div>
                            {this.props.canEdit &&
                            <div>
                                <button
                                    className="light"
                                    onClick={() => {
                                        this.props.onEditClick(planPackage, plan, this.props.isNewPackage);
                                    }}
                                >
                                    Edit
                                </button>
                                <button
                                    style={{marginTop: '10px'}}
                                    className="warning"
                                    onClick={() => {
                                        this.props.onDeleteClicked(planPackage, plan);
                                    }}
                                >
                                    Remove
                                </button>
                            </div>}
                        </div>
                    </div>
                </div>
            );
        });
    }
}


// WEBPACK FOOTER //
// ./src/backoffice/components/billing/PlanPackageView.tsx